// IMAGES

import Icon from '../assets/roulette-pointer.png';

const roulettePointer = new Image();
roulettePointer.src = Icon;

export { roulettePointer };
